__turbopack_context__.v({
  "cardCta": "AlternativeAccommodationCard-module__YQxH1G__cardCta",
  "cardCtaHorizontal": "AlternativeAccommodationCard-module__YQxH1G__cardCtaHorizontal",
  "cardCtaSpinner": "AlternativeAccommodationCard-module__YQxH1G__cardCtaSpinner",
  "cardLink": "AlternativeAccommodationCard-module__YQxH1G__cardLink",
  "cardLinkLabel": "AlternativeAccommodationCard-module__YQxH1G__cardLinkLabel",
  "cardList": "AlternativeAccommodationCard-module__YQxH1G__cardList",
});
